import { render, staticRenderFns } from "./termsComp.vue?vue&type=template&id=130d7872&scoped=true&"
import script from "./termsComp.vue?vue&type=script&lang=js&"
export * from "./termsComp.vue?vue&type=script&lang=js&"
import style0 from "./termsComp.vue?vue&type=style&index=0&id=130d7872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d7872",
  null
  
)

export default component.exports